'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			if (!$(val).text().replace(/(^\s+)|(\s+$)/g, "").length) {
				$(val).addClass('di_none');
			}
		});
		// ニュースカテゴリ空出力の際の消込
		$('.mod-news-item-top-category').each(function (idx, val) {
			if (!$(val).text().replace(/(^\s+)|(\s+$)/g, "").length) {
				$(val).addClass('di_none');
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};

	removeElmIfEmpty();
	removeBlockIfListEmpty();
})(window.jQuery, window.FUNCTIONS);